import React from 'react';
import { Button } from 'LocalGluons';
import { Dimensions, Image, ImageBackground, View } from 'react-native';
import { Device } from 'DeviceUtils';
import { useStore } from 'Store/Store';
import { t } from 'Locale';
import { SIMPLE_NOTIFICATION_PORTRAIT_BACKGROUND, SIMPLE_NOTIFICATION_LANDSCAPE_BACKGROUND } from 'Options';
import { notificationsStylePhone, notificationsStyleWeb } from './SimpleNotificationStyles.jss';
import { logEvent } from 'AppManager';

interface SimpleNotificationResponse {
    imageUrlPortrait: string;
    imageUrlLandscape: string;
    buttonString: string;
}

interface SimpleNotificationProps {
    setModalContent: (newModalContent: any) => void;// (newModalContent: any, hwBackHandler?: any) => void; use this in case of hadling back button case
    notifiactionResponse: SimpleNotificationResponse;
    notificationID: number;
    notificationName?: string;
}

const SimpleNotification = ({
    notifiactionResponse,
    setModalContent,
    notificationID,
    notificationName

}: SimpleNotificationProps) => {
    const { appManager } = useStore();
    const {
        backstageConnector: { notifications }
    } = appManager.getApi();



    // POST
    const handleUnderstandResponse = async () => {
        try {
            await notifications.markSimpleNotification(notificationID, 'read');
            logEvent({
                type: 'action',
                subtype: 'notificationClosed',
                content1: notificationID,
                content2: notificationName,
                context: "buttonClose"
            });
            setModalContent(null);
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <>
            {((Device.isPhone || Device.isTablet) && notifiactionResponse !== null) && (
                <ImageBackground source={
                    Device.isPhone ?
                        SIMPLE_NOTIFICATION_PORTRAIT_BACKGROUND :
                        SIMPLE_NOTIFICATION_LANDSCAPE_BACKGROUND
                }
                    style={notificationsStylePhone.imageBackgroundStyle} >
                    <View style={notificationsStylePhone.contentImageContainer}>
                        <Image
                            source={{
                                uri: Device.isPhone ?
                                    notifiactionResponse!.imageUrlPortrait :
                                    notifiactionResponse!.imageUrlLandscape
                            }}
                            style={notificationsStylePhone.image}
                        />
                    </View>
                    <View style={[notificationsStylePhone.button]}>
                        <Button
                            title={t(notifiactionResponse.buttonString)}
                            onPress={handleUnderstandResponse}

                        />
                    </View>
                </ImageBackground>
            )}
            {Device.isWeb && (
                <View style={notificationsStyleWeb.container}>

                    <View style={notificationsStyleWeb.imagesContainer}>
                        <ImageBackground source={SIMPLE_NOTIFICATION_LANDSCAPE_BACKGROUND}
                            style={notificationsStylePhone.imageBackgroundStyle} >
                            <View style={notificationsStyleWeb.contentImageContainer}>
                                <Image
                                    source={{ uri: notifiactionResponse.imageUrlLandscape }}
                                    style={notificationsStyleWeb.backgroundImage}
                                />
                            </View>
                        </ImageBackground>
                    </View>
                    <View style={notificationsStyleWeb.buttonContainer}>
                        <View style={notificationsStyleWeb.button}>
                            <Button
                                title={t(notifiactionResponse.buttonString)}
                                onPress={handleUnderstandResponse}
                            /></View>
                    </View>

                </View >

            )}
        </>
    );

};

export default SimpleNotification;
